export default function StickyHeader() {
    const eleStr = document.body.dataset.stickyHeaderSpy;
    
    if (eleStr) {
        const target = document.querySelector(eleStr);

        if (target) {
            if (target.getBoundingClientRect().top >= 0) {
                document.body.classList.remove('sticky-header');
            }
            else {
                document.body.classList.add('sticky-header');
            }
    
            window.addEventListener('scroll', function() {
                if (target.getBoundingClientRect().top >= 0) {
                    document.body.classList.remove('sticky-header');
                }
                else {
                    document.body.classList.add('sticky-header');
                }
            });
        }
    }
}
